import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import JS files

// import others files
import useFetch from "../../context/useFetch";

// const bannerImgsList = [bannerSample, bannerSample];

const Banner = (props) => {
  const [currentImgIndex, setCurrentImgIndex] = useState(0);
  const [bannerImgsList, setBannerImgsList] = useState([]);
  const [bannerTitleList, setBannerTitleList] = useState([]);
  const [bannerSubTitleList, setBannerSubTitleList] = useState([]);
  const [bannerIdsList, setBannerIdsList] = useState([]);
  const navigate = useNavigate();

  const getBannerListApi = useFetch({
    method: "get",
    url: "News_Service/get_insurance_banner",
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      let img = [];
      let title = [];
      let subtitle = [];
      let ids = [];
      res.map((it, ind) => {
        img.push(it.news_detail[0].cover);
        title.push(it.news_detail[0].header);
        subtitle.push(it.news_detail[0].sub_header);
        ids.push(it.id);
      });
      setBannerImgsList(img);
      setBannerTitleList(title);
      setBannerSubTitleList(subtitle);
      setBannerIdsList(ids);
    },
  });

  const timeoutRef = useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      setCurrentImgIndex((prevIndex) =>
        prevIndex === bannerImgsList.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => {
      resetTimeout();
    };
  }, [currentImgIndex]);

  return (
    <>
      <div className="relative">
        <div className="w-11/12 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <div
            onClick={() =>
              setCurrentImgIndex((prevIndex) =>
                prevIndex === bannerImgsList.length - 1 ? 0 : prevIndex + 1
              )
            }
            className="bg-mygrays-100 p-1 rounded-lg transition-all hover:scale-110 cursor-pointer absolute top-1/2 left-0 transform  -translate-y-1/2"
          >
            <ArrowBackIosNewIcon className="text-myblacks-400" />
          </div>
          <div
            onClick={() =>
              setCurrentImgIndex((prevIndex) =>
                prevIndex === 0 ? bannerImgsList.length - 1 : prevIndex - 1
              )
            }
            className="bg-mygrays-100 p-1 rounded-lg transition-all hover:scale-110 cursor-pointer absolute top-1/2 right-0 transform  -translate-y-1/2"
          >
            <ArrowForwardIosIcon className="text-myblacks-400" />
          </div>
        </div>
        <div
          className="cursor-pointer"
          onClick={() =>
            navigate(`/news-content/${bannerIdsList[currentImgIndex]}`)
          }
        >
          <img
            src={bannerImgsList[currentImgIndex]}
            className="w-full rounded-t-lg md:rounded-xl md:h-[32rem]"
          />

          <div className="hidden md:block w-11/12 opacity-75 p-4	leading-8 bg-mygrays-100 rounded-lg  cursor-pointer absolute bottom-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <span className="block text-sm md:text-base font-bold text-myblacks-200 ">
              {bannerSubTitleList[currentImgIndex]}
            </span>
            <span className="block text-sm md:text-xl font-bold text-myblacks-400 mt-2">
              {bannerTitleList[currentImgIndex]}
            </span>
          </div>
          <div className="md:hidden p-4	 bg-mygrays-100 rounded-b-lg  cursor-pointer leading-8">
            <span className="block text-xs md:text-xl font-bold text-myblacks-200">
              {bannerSubTitleList[currentImgIndex]}
            </span>
            <span className="block text-sm md:text-xl font-bold text-myblacks-400 mt-4">
              {bannerTitleList[currentImgIndex]}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
